export default __webpack_public_path__ + "static/media/icon-unselected-visit.4b3fc9d3.svg";